var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMimired(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 623.9 604.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e59f3c;}.cls-2{fill:#fff;stroke:#e59f3c;}.cls-2,.cls-3{stroke-miterlimit:10;stroke-width:4px;}.cls-3{fill:none;stroke:#1f2dd9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "290.55 598.23 356.2 461.46 525.8 461.46 615.77 596.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "358.87 461.46 528.34 461.46 617.36 314.25 534.09 169.14 358.87 171.5 274.13 316.48 358.87 461.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "100.72 316.48 273.64 316.48 360.09 169.14 273.64 21.81 100.72 21.81 14.26 169.14 100.72 316.48"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.02,
    cy: 21.81,
    r: 19.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 19.81,
    cy: 169.14,
    r: 19.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 291.31,
    cy: 584.77,
    r: 19.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 273.64,
    cy: 21.81,
    r: 19.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 102.35,
    cy: 316.48,
    r: 19.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 604.09,
    cy: 584.77,
    r: 19.81
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMimired);
export default __webpack_public_path__ + "static/media/mimired.9e8af31dc0261520e3199686964debed.svg";
export { ForwardRef as ReactComponent };